import { render, staticRenderFns } from "./AsideMenu.vue?vue&type=template&id=88b5a106&scoped=true"
import script from "./AsideMenu.vue?vue&type=script&lang=js"
export * from "./AsideMenu.vue?vue&type=script&lang=js"
import style0 from "./AsideMenu.vue?vue&type=style&index=0&id=88b5a106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b5a106",
  null
  
)

export default component.exports